import { AuthGuard } from './authentication.guard';
import { IWizRoute } from '@wizeoo/akm-component-lib';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, Router } from '@angular/router';
import { Injectable } from '@angular/core';
import { StaticFeatureEnum } from '@wizeoo/akm-common-lib';
import { Model } from 'src/app/model/model';
import { RouteEngine } from './route.engine';

@Injectable({ providedIn: 'root' })
export class PermissionCheckGuard implements CanActivate {
  constructor(private authGuard: AuthGuard, private router: Router) {}

  async canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    const iwizroute: IWizRoute = route.routeConfig as IWizRoute;
    // console.log('canActivate permission', iwizroute);
    if (!iwizroute.featureCode || iwizroute.featureCode === StaticFeatureEnum.DASHBOARD_DATA) {
      return true;
    }

    if (Model.getInstance().permissionEngine.canRead(iwizroute.featureCode)) {
      return true;
    } else {
      // console.log('canActivate permission failed', iwizroute);
      return this.router.createUrlTree([RouteEngine.DASHBOARD_DATA_VIEW], { ...route,});
    }
  }
}
